const CompanyEndpoint = {
  publicInformation (company_id) {
    return {
      url: `/account_information/${company_id}`,
      method: 'GET'
    }
  },
  show () {
    return {
      url: '/companies',
      method: 'GET',
    }
  },
  create (body) {
    return {
      url: '/companies',
      method: 'POST',
      body: JSON.stringify(body)
    }
  },
  update (body, id) {
    return {
      url: `/companies/${id}`,
      method: 'PUT',
      body: JSON.stringify({ 'company': body })
    }
  },
  updateAccountInfo(body, id) {
    return {
      url: `/companies/info/${id}`,
      method: 'PATCH',
      body: JSON.stringify(body)
    }
  },
  update_stripe (body) {
    return {
      url: '/update_stripe',
      method: 'PATCH',
      body: JSON.stringify({ 'company': body })
    }
  },
}

export default CompanyEndpoint



// WEBPACK FOOTER //
// ./src/persistence/CompanyEndpoint.js